import { dayjs } from "@/config/dayjs";
import { SCANNER_TYPE } from "@/pages/scanner-control/config";
import type { PipeScanners, PipeScannersResult } from "@/types/pipeScanners";

import { rangeFiltering } from "@/utils/filterHelpers";

export function filterScanners(
  scanners: PipeScanners[keyof PipeScanners],
  scannerType,
  filters
) {
  const {
    search,
    inspectionDateRange: [dateFrom, dateTo],
    materials,
    diameterRange,
    constuctionYearRange: [constuctionFrom, constuctionTo],
  } = filters;

  let filteredScanners: typeof scanners = scanners.filter(
    (scanner) =>
      dayjs(scanner?.inspection_date).isSameOrAfter(dayjs(dateFrom)) &&
      dayjs(scanner?.inspection_date).isSameOrBefore(dayjs(dateTo))
  );

  if (materials.length) {
    filteredScanners = filteredScanners.filter((scanner) =>
      materials.includes(scanner?.material)
    );
  }

  if (search.length > 2 && scannerType !== SCANNER_TYPE.INFO_PENDING) {
    const normalizedSearch = search.toLowerCase().trim();

    filteredScanners = filteredScanners.filter((scanner) => {
      let tag = "";
      let address = "";
      if ("tag" in scanner) tag = (scanner.tag as string).toLowerCase().trim();
      if ("address" in scanner)
        address = (scanner.address as string)?.toLowerCase().trim();

      return (
        tag.includes(normalizedSearch) || address?.includes(normalizedSearch)
      );
    });
  }

  if (scannerType === SCANNER_TYPE.RESULTS) {
    filteredScanners = rangeFiltering(
      filteredScanners as PipeScannersResult[],
      "diameter",
      diameterRange
    );

    if (constuctionFrom.length === 4) {
      filteredScanners = filteredScanners.filter((scanner) =>
        (scanner as PipeScannersResult)?.constructionyear
          ? constuctionFrom <= (scanner as PipeScannersResult).constructionyear
          : false
      );
    }

    if (constuctionTo.length === 4) {
      filteredScanners = filteredScanners.filter((scanner) =>
        (scanner as PipeScannersResult)?.constructionyear
          ? constuctionTo >= (scanner as PipeScannersResult).constructionyear
          : false
      );
    }
  }

  return filteredScanners;
}
